<template>
  <router-view />
</template>
<script>
  export default {
    name: 'UnidadeNegocioModule',
  }
</script>
